var map = {
	"./9MileWodka.png": 3969,
	"./Aljo Olio.png": 1002,
	"./Aperol Spritz.png": 1420,
	"./AperolSpritz.png": 1058,
	"./Arabiata.png": 4658,
	"./Avocado Salad.png": 7525,
	"./Avocado.png": 6286,
	"./Baileys auf Eis.png": 2797,
	"./Bananenweizen.png": 6458,
	"./Bianca.png": 4931,
	"./BierAlkoholfrei.png": 8835,
	"./BitburgerAlkoholfrei.png": 2867,
	"./BitburgerPils.png": 37,
	"./Bolognese.png": 5575,
	"./BombayGinTonicWater.png": 217,
	"./BombayGinWildBerry.png": 621,
	"./Bresaola.png": 4340,
	"./Bufala.png": 2636,
	"./Buratta.png": 4440,
	"./Caesar.png": 4644,
	"./CafeCreme.png": 5422,
	"./Cappuccino.png": 7680,
	"./Caprese.png": 578,
	"./Capricciosa.png": 7912,
	"./Carbonara.png": 9766,
	"./Chicken.png": 2820,
	"./Classic.png": 6353,
	"./Colzone (2).png": 5782,
	"./Colzone.png": 1193,
	"./Crema Di fungi.png": 4245,
	"./Diavola.png": 4363,
	"./DoppelterEspresso.png": 9416,
	"./ErdingerWeizen.png": 2169,
	"./Espresso.png": 8013,
	"./EspressoCorretto.png": 9291,
	"./EspressoMacchiato.png": 7124,
	"./Formaggi.png": 9303,
	"./FrischerMinztee.png": 4837,
	"./Funghi.png": 6994,
	"./Gamberetti.png": 8115,
	"./Gamberi.png": 9564,
	"./Getränke.png": 861,
	"./Gnocchi Pesto.png": 4587,
	"./Gnocchi Pomodoro.png": 1699,
	"./Greek.png": 3217,
	"./Hugo alkoholfrei.png": 3806,
	"./Hugo.png": 6294,
	"./HugoAlkoholfrei.png": 4896,
	"./Jack Daniels Cola.png": 5429,
	"./JackDanielsCola.png": 1805,
	"./JohnnyWalkerCola.png": 6872,
	"./Kamillentee.png": 9254,
	"./Lasagna Classic.png": 766,
	"./Lasagna Verdura.png": 9299,
	"./Lasagne.png": 1686,
	"./LatteMacchiato.png": 7654,
	"./Leonardo.png": 1073,
	"./Lillet Berry.png": 2243,
	"./Lillet alkoholfrei.png": 5299,
	"./LilletAlkoholfrei.png": 8507,
	"./LilletBerry.png": 8555,
	"./Margherita.png": 5657,
	"./Marinara.png": 1416,
	"./Milchkaffee.png": 60,
	"./Mortadella E Buratta.png": 438,
	"./Napoletana.png": 9806,
	"./New York.png": 9414,
	"./Nicoise.png": 4359,
	"./Nutella Calzone.png": 8312,
	"./Parmigiana.png": 6630,
	"./Pasta Burata.png": 9023,
	"./Pasta El Manzo.png": 9996,
	"./Pesto Basilikum.png": 9245,
	"./Philly Cheese Steak.png": 8362,
	"./Pinot grigio vero vitae.png": 997,
	"./Pizza Nutella.png": 8876,
	"./Pomodoro.png": 4268,
	"./Primitivo Trocken.png": 5266,
	"./Prosciutto E Funghi.png": 3849,
	"./Prosecco Spumante alkoholfrei.png": 9572,
	"./ProseccoSpumanteAlkoholfrei.png": 9242,
	"./Quattro Formaggi.png": 3497,
	"./Radler.png": 7123,
	"./Ratatouille.png": 7810,
	"./Salami.png": 4162,
	"./Salat Gamberetto.png": 2212,
	"./Salat Tooni.png": 2379,
	"./Salata Manzo.png": 9464,
	"./Salata Manzo.webp": 1285,
	"./Salata Pollo.png": 9911,
	"./Salmone.png": 1818,
	"./Salsiccia E Friarielli.png": 5209,
	"./Salsiccia E Patat.png": 3564,
	"./Salsiccia E Patata.png": 7599,
	"./Salsiccia Pasta.png": 464,
	"./Schoko Souffle.png": 836,
	"./SchwarzerTee.png": 4938,
	"./Tartufata.png": 6759,
	"./Tiramisu.png": 5973,
	"./Tonno.png": 1043,
	"./Vegan.png": 8370,
	"./Verdura.png": 9140,
	"./Whiskey Sour's.png": 5962,
	"./Wurttemberger Blanc de Noir.png": 3563,
	"./aperol_sours.png": 561,
	"./baileys_auf_eis.png": 4345,
	"./chianti_trocken.png": 760,
	"./cola.png": 5618,
	"./cola_zero.png": 5241,
	"./fanta.png": 695,
	"./gin_sours.png": 2176,
	"./jagermeister.png": 6907,
	"./lambrusco_fruchtig.png": 2714,
	"./mezzo_mix.jpg": 1447,
	"./pinot_meunier_rose_halbtrocken.png": 9117,
	"./primitivo_trocken.png": 7955,
	"./ramazotti_auf_eis_mit_zitrone.png": 1080,
	"./sambuca.png": 615,
	"./sprite.png": 4298,
	"./tequila.png": 6580,
	"./weinschorle.png": 5126,
	"./whiskey_sours.png": 1704,
	"./wurttemberger_trollinger_halbtrocken.png": 7627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4233;